import React from "react";
import {toJS, values} from "mobx";
import {observer} from "mobx-react";

import board_cast from '@common/BoardCast';

import {DatePicker,Row,Col,Input,Select,Radio,AutoComplete,Button} from "antd";

import {exportFile} from "@src/Utils";
import moment from 'moment';
import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import GoToPage from '@common/GoToPage';

import Member_purchase_store,{pagination_store,filter_store,item_store} from '@store/Purchase/MemberPurchaseStore';

const { RangePicker } = DatePicker;

@observer
class MemberPurchaseForm  extends React.Component
{
    render() {
        return (
            <Row type={"flex"}>
                <Col style={{lineHeight:'34px'}}>
                    <MySearchComponent
                        defaultValue={{
                            nick_name:filter_store.nick_name?filter_store.nick_name:'',
                            pet_name:filter_store.pet_name?filter_store.pet_name:'',
                            agent:filter_store.agent?filter_store.agent:'',
                            giveType:filter_store.giveType?filter_store.giveType:'',
                            search:filter_store.search?filter_store.search:'',
                            date:filter_store.start_time != undefined?[filter_store.start_time,filter_store.end_time]:[]
                        }}
                        onClick={(values)=>{
                            let agent = values.agent;
                            if (agent === '') agent = undefined;
                            let search = values.search;
                            if (search === '') search = undefined;
                            let filter = {
                                agent:agent,
                                search:search,
                                type:2,
                                type_time:values.type_time || 6
                            }
                            Member_purchase_store.reloadDatas(filter);
                        }}
                        />
                </Col>
            </Row>
        )
    }
}

export default MemberPurchaseForm;


// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/memberPurchase/MemberPurchaseForm.jsx